import * as React from 'react'
import { HeadBar } from '../shared/components'
import { SettingsIcon } from '@/app/features/icons/Settings'

type Props = {
  children: React.ReactNode

}

export const ProfileLayout = ({ children }: Props) => {
  return (
    <div className="module-imports tw-padding-4 tw-m-1 tw-flex tw-min-w-[900px] tw-max-h-[calc(100vh-8px)] tw-flex-[1] tw-flex-col tw-overflow-y-hidden tw-rounded-xl tw-border tw-border-base-300 tw-bg-base-100 tw-text-content-base">
      <HeadBar title={'Mój profil'} icon={<SettingsIcon />} />

      <main className="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col">{children}</main>
    </div>
  )
}
